/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ImagesheetprintingsQueryResponse } from '../../types/GetV1Imagesheetprintings.ts'

export const getV1ImagesheetprintingsQueryKey = () => [{ url: '/v1/ImageSheetPrintings' }] as const

export type GetV1ImagesheetprintingsQueryKey = ReturnType<typeof getV1ImagesheetprintingsQueryKey>

/**
 * {@link /v1/ImageSheetPrintings}
 */
export async function getV1Imagesheetprintings(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ImagesheetprintingsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ImageSheetPrintings`, ...requestConfig })
    return res
}

export function getV1ImagesheetprintingsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ImagesheetprintingsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ImagesheetprintingsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ImagesheetprintingsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Imagesheetprintings(config)
        },
    })
}

/**
 * {@link /v1/ImageSheetPrintings}
 */
export function useGetV1Imagesheetprintings<
    TData = ResponseConfig<GetV1ImagesheetprintingsQueryResponse>,
    TQueryData = ResponseConfig<GetV1ImagesheetprintingsQueryResponse>,
    TQueryKey extends QueryKey = GetV1ImagesheetprintingsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ImagesheetprintingsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ImagesheetprintingsQueryKey()

    const query = useQuery(
        {
            ...getV1ImagesheetprintingsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
